export default __webpack_public_path__ + "static/slider4-58b5e0384d71ff9f72544d9c6163a611.jpg";